import React from 'react'
import PropTypes from 'prop-types'
import Splash from 'App/Splash'
import userManager from './userManager'

const isEmpty = val => {
  return (val === undefined || val == null || val.length <= 0)
}

const goToError = history => {
  userManager
    .removeUser()
    .then(() => history.push('/404'))
}

const Session = ({ history, location: { hash } }) => {
  const refreshToken = hash.replace('#/', '')

  if (isEmpty(refreshToken)) {
    goToError(history)
  } else {
    userManager.signinWithRefreshToken(refreshToken)
      .then(user => history.push('/'))
      .catch(() => goToError(history))
  }

  return (<Splash text='Realizando o login...' />)
}

Session.propTypes = {
  history: PropTypes.object,
  location: PropTypes.shape({
    hash: PropTypes.string.isRequired
  })
}

export default Session



// WEBPACK FOOTER //
// ./src/Auth/Session.js